/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let authAPI = window._env_.VUE_APP_AUTH_HOST

export const changePassword = params => {
  return axios.post(`${base}/change_password`, params)
}

export const reinforcesWitch = params => {
  return axios.get(`${authAPI}/reinforceswitch`, params)
}

export const setProjectConfig = params => {
  return axios.post(`${base}/setting/set_project_config`, params)
}
export const getProjectConfig = params => {
  return axios.get(`${base}/setting/get_project_config`, {params})
}
export const setReceiptApplyConfig = params => {
  return axios.post(`${base}/setting/set_receipt_apply_config`, params)
}
export const getReceiptApplyConfig = params => {
  return axios.get(`${base}/setting/get_receipt_apply_config`, {params})
}
export const uploadSJIdCardRegionFileApi = params => {
  return axios.post(`${base}/setting/upload_sjidcard_region`, params)
}
export const getSJIdCardRegionFileApi = params => {
  return axios.get(`${base}/setting/get_sjidcard_region`, {params})
}



// WEBPACK FOOTER //
// ./src/views/settings/settings.api.js